import React from 'react';
import { StyleSheet } from 'react-native';
import { useThemeContext } from '../../hook/useThemeManager';
import { AppBar, Toolbar, Box, Typography, Icon, Link } from '@mui/material';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { ThspianFullLogo } from '../ThspianLogo/ThspianFullLogo';
import { ROUTES } from '../../types/global/routes.types';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import { useLogoHomeNavigation } from '../../hook/useLogoHomeNavigation';
import { en_config } from '../../config';
import { Situation } from '../Situation/Situation';
import ArrowRightIcon from '../CustomSVGIcons/ArrowRightIcon';
interface ISignUpHeader {
    label?: string;
    /** The route that the label will point to */
    route?: string;
    onClick?: () => void;
    navigateOptions?: NavigateOptions;
    arrowColor?: string;
}

const EsSignupHeader: React.FC<ISignUpHeader> = ({ label, route, onClick, navigateOptions, arrowColor }) => {
    const { themeStyle } = useThemeContext();
    const navigate = useNavigate();
    const styles = dynamicStyles(themeStyle);
    const { handleLogoClick } = useLogoHomeNavigation({
        onDefaultNavigate: () => navigate(ROUTES.FEED),
    });

    const handleLinking = () => {
        if (onClick) {
            onClick();
            return;
        }
        if (route) {
            navigate(route, {
                ...navigateOptions,
            });
            return;
        }
    };

    return (
        <Box style={styles.container}>
            <AppBar position="static" style={styles.bg}>
                <Toolbar
                    sx={{
                        paddingInline: { xs: '16px', md: '24px', lg: '40px' },
                        paddingTop: { xs: '32px', sm: '40px' },
                        paddingBottom: { xs: '32px', sm: '40px' },
                    }}>
                    <Box display="flex" flexGrow={1}>
                        <Link
                            href={ROUTES.FEED}
                            sx={{
                                width: { xs: '125px', sm: '170px' },
                                height: { xs: '18px', sm: '24px' },
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                zIndex: 99999,
                            }}>
                            <ThspianFullLogo
                                width={'120px'}
                                height={'40px'}
                                fill={theme[themeStyle].logo_color}
                                onClick={handleLogoClick}
                            />
                            {en_config.IS_BETA && <Situation label="beta" />}
                        </Link>
                    </Box>
                    <Link
                        onClick={handleLinking}
                        sx={{
                            '&:hover': { cursor: 'pointer' },
                            textDecoration: 'none',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <Typography
                            style={{
                                ...styles.text,
                                color: arrowColor ?? theme[themeStyle].true_white,
                            }}
                            sx={{ fontSize: { xs: '14px', sm: '16px' } }}>
                            {label ?? 'Sign in'}
                        </Typography>
                        <Icon
                            sx={{
                                width: { xs: '18px', sm: '24px' },
                                height: { xs: '18px', sm: '24px' },
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                            }}>
                            <ArrowRightIcon
                                style={{ width: '100%', height: '100%' }}
                                fill={arrowColor ?? theme[themeStyle].true_white}
                            />
                        </Icon>
                    </Link>
                </Toolbar>
            </AppBar>
        </Box>
    );
};
const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        container: {
            width: '100vw',
            position: 'absolute',
            top: 0,
        },
        bg: {
            backgroundColor: theme[colorScheme].transparent,
            boxShadow: 'none',
        },
        text: {
            color: theme[colorScheme].true_white,
            marginRight: 8,
            fontFamily: FONT_ENUM.MAIN_REGULAR,
        },
    });

export { EsSignupHeader };
